<template>
  <smd-one-col-layout class="root-services-past"
                      :content-styles="contentStylesClass">
    <full-screen-loader class="root-services-past__loader" v-if="medicineOrdersLoading"/>
    <smd-search v-if="!(searchString === '' && filteredOrders.length === 0)"
                v-model.trim="searchString"
                :class="$isMobile ? 'm-b-15' : 'm-b-50'"
                :custom-placeholder="getElementString('txt322')"/>

    <empty-screen v-if="searchString === '' && filteredOrders.length === 0" icon="ns-icon-ico051"
                  text-string="txt172">
      <text-string v-bind="findAServiceTextStringProps"
                   class="m-t-15 text-center"/>
    </empty-screen>

    <empty-screen v-if="searchString !== '' && filteredOrders.length === 0" icon="ns-icon-ico044"
                  text-string="txt138">
    </empty-screen>

    <div v-if="!medicineOrdersLoading" class="services-list">
      <service-order-card v-for="order in filteredOrders"
                          :key="order.orderid"
                          :order="order"
                          class="m-t-15"
                          @click="viewOrderDetails(order)"/>
    </div>
  </smd-one-col-layout>
</template>

<script>
  import {mapGetters} from 'vuex';
  import {GETTER_PAST_MEDICINE_ORDERS,} from '@/store/types';
  import GetElementString from "@/mixins/get-element-string";
  import MedicineOrdersMixin from '@/mixins/services/medicine-orders-mixin';

  export default {
    name: 'root-services-past',
    mixins: [
      GetElementString,
      MedicineOrdersMixin,
    ],
    computed: {
      ...mapGetters({
        serviceOrders: GETTER_PAST_MEDICINE_ORDERS,
      }),
      contentStylesClass() {
        return [{'dark-light-bg': !this.$isMobile}, 'root-services-past__content']
      }
    },
  }
</script>

<style lang="scss">
  @import "~@/assets/styles/util.scss";

  .root-services-past__content {
    > div {
      @include set-max-width($max-width: 1583px);
    }

    @include responsive('min-width: 1024px') {
      padding: space(xxl) !important;

      .smd-form--search {
        max-width: 792px;
      }
    }
  }

  .root-services-past {
    .services-list {
      .service-order-card {
        cursor: pointer;

        &:hover {
          box-shadow: $desktop-purple-hover;
        }
      }
    }
  }

  .root-services-past__loader {
    position: fixed !important;
  }
</style>
